<template>
    <!-- 数字通证管理 -->
    <div>
        <!-- 内容区域 -->
        <div>
            <el-table :data="form" border style="width: 100%">
                <el-table-column prop="agreementId" label="同意协议ID" align="center">
                </el-table-column>
                <el-table-column prop="name" label="协议标题" align="center">
                </el-table-column>
                <!-- <el-table-column prop="content" label="协议内容" align="center">
                </el-table-column> -->
                <el-table-column prop="userId" label="用户ID" align="center">
                </el-table-column>
                <el-table-column prop="userName" label="用户昵称" align="center">
                </el-table-column>
                <el-table-column prop="userTel" label="用户账号" align="center">
                </el-table-column>
            </el-table>
        </div>
        <div class="pagination">
            <el-pagination @size-change="handleSizeChange" @current-change="handleCurrentChange" :current-page="currentPage"
                :page-sizes="[10, 15, 20, 30]" :page-size="pageSize" layout="total, sizes, prev, pager, next, jumper"
                :total="total">
            </el-pagination>
        </div>
        <el-dialog title="提现黑名单" :visible.sync="dialog" width="1000px" center>
            <AddAgreement @close="closeDialog" :param="param"></AddAgreement>
        </el-dialog>
    </div>
</template>
  
<script>
import AddAgreement from './addAgreement.vue'
export default {
    components: {
        AddAgreement
    },
    data() {
        return {
            form: [],
            total: 0,
            pageSize: 10,
            currentPage: 1,
            dialog: false,
            param: {
                name: '',
                content: '',
                createTime: '',
                id: null,
                status: 1
            }
        };
    },
    mounted() {
        this.getList();
    },
    methods: {
        closeDialog() {
            this.dialog = false
        },
        getList() {
            this.axios
                .get("/admin/userAgreement/findAll", {
                    pageNumber: this.currentPage,
                    pageSize: this.pageSize,
                })
                .then((res) => {
                    this.form = res.data.data.records;
                    this.total = res.data.data.total;
                });
        },
        editInfo(row) {
            this.param = JSON.parse(JSON.stringify(row))
            this.dialog = true
        },
        addAgreement() {
            // this.$router.push('addAgreement')
            this.dialog = true
        },
        // 分页
        handleSizeChange(val) {
            this.pageSize = val;
            this.getList();
        },
        handleCurrentChange(val) {
            this.currentPage = val;
            this.getList();
        },
    },
};
</script>
  
<style lang="scss" scoped>
.onBtn {
    display: flex;
    align-items: center;
    padding: 20px;
}

.btn {
    display: flex;
    justify-content: center;

    div {
        margin: 0 3px;
        font-size: 12px;
        color: #409eff;
    }

    div:hover {
        cursor: pointer;
    }
}

.pagination {
    display: flex;
    justify-content: center;
    margin-top: 50px;
}
</style>